export default __webpack_public_path__ + "static/media/S.d0567bec.png";